import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import electionImage from "../assets/images/vision.jpg";
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/AiotaElection.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const AiotaElections = () => {
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleReadMore = () => {
    window.open(
      "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/Election_Result__Website.pdf",
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <Container className="elections-container">
            <h2 className="aiota-election-heading">AIOTA Elections</h2>{" "}
            <Row className="align-items-start">
              <Col lg={6} className="col-12">
                <p className="text">
                  The AIOTA Elections are conducted by the All India
                  Occupational Therapists’ Association to democratically elect
                  members of its Executive Committee for a four-year term. These
                  elections are now held online to ensure transparency and ease
                  of participation. Positions filled through the election
                  include the President, Vice-President, Secretary, Treasurer,
                  and four Executive Committee Members. Only active life members
                  who have renewed their membership after 2008–2009 are eligible
                  to vote. Members interested in contesting must meet specific
                  eligibility criteria based on their prior involvement in the
                  organization.
                </p>
                <p className="text">
                  For example, candidates for the position of President must
                  have previously held an office-bearer post, while those
                  contesting for Secretary or Treasurer must have served at
                  least two terms as an EC member. The election process includes
                  submitting a nomination form endorsed by two members, along
                  with a deposit of ₹5,000. The process is overseen by an
                  independent Chairperson and Election Committee to maintain
                  fairness and integrity. Voting is OTP-verified, secure, and
                  results are announced during the General Body Meeting. These
                  elections play a vital role in shaping the leadership and
                  strategic direction of AIOTA, ensuring active member
                  participation in its governance.
                </p>
                {/* <Button
                  className="w-auto d-flex justify-content-between align-items-center"
                  onClick={handleReadMore}
                >
                  READ MORE
                  <FaArrowRight size={24} className="ms-3" />
                </Button> */}
              </Col>
              <Col md={6} className="d-none d-lg-block">
                <div className="election-image-container">
                  <img
                    src={electionImage}
                    alt="AIOTA Elections"
                    className="img-fluid election-image"
                  />
                  {/* <button className="read-more-button" onClick={handleReadMore}>
  READ MORE
  <span className="material-symbols-outlined">arrow_forward</span>
</button> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default AiotaElections;
